export default "__VITE_ASSET__DZfjhYS$__"